import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import { ConditionalRendering } from '../conditional-rendering';

const Checkbox = props => {
    const {
        checked = false,
        classes,
        disabled,
        id,
        inputClasses,
        isInputRequired,
        name,
        labelClasses,
        text: labelText,
        showRequired,
        handleChange,
        handleBlur,
        values,
        layout,
        fieldArrayIndex = undefined,
        fieldArray = [],
    } = props;

    const handleValueChange = e => {
        const { name, checked } = e.target;
        handleChange({ target: { name, value: checked } }, fieldArray, fieldArrayIndex);
        handleBlur({ target: { name, value: checked } }, fieldArray, fieldArrayIndex);
    };
    const handleValueBlur = e => {
        const { name, checked } = e.target;
        handleBlur({ target: { name, value: checked } }, fieldArray, fieldArrayIndex);
    };

    const keyPress = e => {
        const isEnterOrSpace =
            e.key === ' ' || e.key === 'SpaceBar' || e.key === 'Enter' || e.keyCode === 32 || e.keyCode === 13;
        if (isEnterOrSpace) {
            handleValueChange(e);
            handleValueBlur(e);
        }
    };

    return (
        <div className={`gi-checkbox ${classes && classes.join(' ')}`}>
            <Fragment>
                {layout !== 'block' && (
                    <input
                        id={id}
                        name={name}
                        className={`usa-checkbox__input gi-checkbox__input ${
                            inputClasses && inputClasses.join(' ')
                        } required-${isInputRequired}`}
                        type="checkbox"
                        role="checkbox"
                        aria-checked={checked}
                        aria-required={isInputRequired}
                        data-value={checked}
                        aria-labelledby={`checkbox_${id}_label`}
                        onChange={e => handleValueChange(e)}
                        onBlur={e => handleValueBlur(e)}
                        onKeyPress={keyPress}
                        disabled={disabled}
                        checked={checked}
                        value={values}
                    />
                )}
                <label
                    id={`checkbox_${id}_label`}
                    data-automation-id={`checkbox_${id}_label`}
                    htmlFor={id}
                    data-value={checked === null ? '' : checked}
                    //onClick={ (e) => handleValueChange(e) }
                    className={`usa-checkbox__label gi-checkbox__label ${
                        labelClasses && labelClasses.join(' ')
                    } required-${showRequired}`}
                >
                    <ConditionalRendering isTrue={labelText}>
                        <FormattedMessage id={labelText} />
                    </ConditionalRendering>

                    {layout === 'block' && (
                        <input
                            id={id}
                            name={name}
                            className={`usa-checkbox__input gi-checkbox__input ${
                                inputClasses && inputClasses.join(' ')
                            } required-${isInputRequired}`}
                            type="checkbox"
                            role="checkbox"
                            aria-checked={checked}
                            aria-required={isInputRequired}
                            data-value={checked}
                            aria-labelledby={`checkbox_${id}_label`}
                            onChange={e => handleValueChange(e)}
                            onKeyPress={keyPress}
                            disabled={disabled}
                            value={values}
                            checked={checked}
                        />
                    )}
                </label>
            </Fragment>
        </div>
    );
};

export default Checkbox;
